import React, {PropTypes} from 'react';

const SearchField = (props) => (
  <input type="text" name="search" className="basic-input search-box" placeholder="Hledat..." onChange={(e) => props.handleChange(e.target.value)} />
)

export default SearchField



// WEBPACK FOOTER //
// ./src/browser/components/stateless/SearchField.react.js